// extracted by mini-css-extract-plugin
module.exports = {"success":"SuccessPage_success__LaNX0"};